export default "__VITE_ASSET__Dp0F2hSY__"